/**
 * Created by DejanK on 7/10/2017
 *
 */

export default rbFixedOnScrollY;

function rbFixedOnScrollY(){
  return {
    restrict: 'A',
    require: '^rbFixedOnScrollContainer',
    //scope: {
    //  maskBackground: '@',
    //  rbFixedTableHeader: '@'
    //},
    controller: Ctrl,
    scope: true
    //controllerAs: '$ctrl',
    //bindToController: true
  }
}

Ctrl.$inject = ['$element', '$scope'];
function Ctrl($element, $scope){
  const offset = 44;
  let lastIsFocused;

  $scope.$on('RB_SCROLL_EVENT', (event, data)=>{
    const topDiff = data.element.getBoundingClientRect().top - $element[0].getBoundingClientRect().top + offset;
    const isFocused = topDiff < 20 && topDiff > -92;

    if(isFocused !== lastIsFocused){
      lastIsFocused = isFocused;
      if (isFocused) {
        $element.removeClass('blurred');
      } else {
        $element.addClass('blurred');
      }
      $scope.$broadcast('RB_AMENITIES_FOCUSED', {isFocused: isFocused});
    }
  });
}
